export function isRgb(value) {
    return value.r !== undefined;
}
export function isRgba(value) {
    return isRgb(value) && value.a !== undefined;
}
export function isCmyk(value) {
    return value.c !== undefined;
}
export function isCmyka(value) {
    return isCmyk(value) && value.a !== undefined;
}
export function isHsl(value) {
    return value.h !== undefined && value.l !== undefined;
}
export function isHsv(value) {
    return value.h !== undefined && value.v !== undefined;
}
export function isParsedColor(value) {
    return value.colorSpace !== undefined;
}
//# sourceMappingURL=typeDetection.js.map